// Module
var code = "<script>let $ctrl</script> <atom-text ng-if=\"$ctrl.finalValue !== undefined\">{{ $ctrl.finalValue }}</atom-text> <atom-text ng-if=\"$ctrl.finalValue === undefined\">-</atom-text> ";
// Exports
module.exports = code;